import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import translate from "../../reusable/translate";
import {
  getCommitmentTypeId,
  getCommitmentTypeName,
} from "../../materialCommitment/helpers/Categories";

const CategorySelection = ({
  setCategorySelected,
  setMetaData,
  commitmentType,
}) => {
  const [categoryId, setCategoryId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [commitmentTypeName, setCommitmentTypeName] = useState("");

  useEffect(() => {
    const id = getCommitmentTypeId(commitmentType);
    setCommitmentTypeName(getCommitmentTypeName(commitmentType));
    const fetchData = async () => {
      const data = await fetch(
        `/o/commitment2050-service/commitmentapi/categories/${id}`
      );
      return await data.json();
    };
    fetchData().then((res) => setCategories(res.children));
  }, []);

  useEffect(() => {
    setSubCategories(
      categories.find(
        (mappedCategory) => mappedCategory.categoryId === categoryId
      )
    );
  }, [categoryId]);

  const setProps = () => {
    const mainCategory = categories.find(
      (mappedCategory) => mappedCategory.categoryId === categoryId
    );
    const subCategory = subCategories.children.find(
      (mappedCategory) => mappedCategory.categoryId === subCategoryId
    );
    const mainGoal = mainCategory.properties.mainGoal;
    const operationsTemplateFolder =
      subCategory.properties.operationTemplatesFolder ||
      mainCategory.properties.operationTemplatesFolder;
    setMetaData(
      Number(mainGoal),
      Number(operationsTemplateFolder),
      Number(categoryId),
      Number(subCategoryId)
    );
    setCategorySelected(true);
  };

  return (
    <div className="category-container">
      <div className="flex-row items-center space-between">
        <Link to="/tee-sitoumus">
          <button className="green-button">
            <i className={"fas fa-chevron-left"} />{" "}
            {translate({ textKey: "sit.back" })}
          </button>
        </Link>
        <h2 className="h2">{commitmentTypeName}</h2>
      </div>
      <div className="flex-column">
        <h4 className="margin-top-bot">
          <b>
            Mihin {commitmentTypeName.toLowerCase()} -sopimukseen haluat
            sitoutua?
          </b>
        </h4>
        <select
          id="chooseDeal"
          className="select-full-width margin-top-bot"
          onChange={(e) => setCategoryId(e.target.value)}
        >
          <option value="">
            {translate({ textKey: "sit.categorySelection.chooseDeal" })}
          </option>
          {categories.map((mappedCategory) => (
            <option
              key={mappedCategory.categoryId}
              value={mappedCategory.categoryId}
            >
              {mappedCategory.name}
            </option>
          ))}
        </select>

        <select
          id="chooseLineOfBusiness"
          className="select-full-width"
          onChange={(e) => setSubCategoryId(e.target.value)}
        >
          <option value="">
            {translate({
              textKey: "sit.categorySelection.chooseLineOfBusiness",
            })}
          </option>
          {subCategories &&
            subCategories.children &&
            subCategories.children.map((mappedCategory) => (
              <option
                key={mappedCategory.categoryId}
                value={mappedCategory.categoryId}
              >
                {mappedCategory.name}
              </option>
            ))}
        </select>
      </div>
      <button
        className={`add-button margin-top-bot ${
          categoryId && subCategoryId ? "" : "add-button-disabled"
        }`}
        onClick={() => setProps()}
        disabled={!categoryId || !subCategoryId}
      >
        {translate({
          textKey: "sit.commitment.greenDeal.categorySelect.continueButtonText",
        })}
        <i className="fas fa-chevron-right" />
      </button>
    </div>
  );
};

export default CategorySelection;



// WEBPACK FOOTER //
// ./src/components/profile/createCommitment/CategorySelection.js